import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetRolesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/inputs/get-roles-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchRoleListContext } from '../../role.context';
import { RoleListFilterSearchFormStep1Controller } from '../role-list-filter-search-form-step-1/role-list-filter-search-form-step-1.controller';

export interface RoleListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetRolesPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetRolesPaginatedModel>;
  onCancel: () => void;
}

export const RoleListFilterSearchFormController = (
  props: RoleListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchRoleListContext();

  return (
    <HeadlessFormProvider<GetRolesPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <RoleListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
